class BannerVideo {
  constructor() {
    this.players = {};
    this.init();
    this.timeDelay = 2000;
    this.videosSetup = false;
    this.attributes = {
      autoplay: 'autoplay',
      loop: 'loop',
      muted: 'muted',
      controls: 'controls',
      mediaLibrary: 'media_library',
      external: 'external',
      autoplayLoop: 'autoplay_loop',
      hideControls: 'hide_controls',
    }
  }

  init() {
    this.delay(() => {
      this.setupVideoPlayers();
    }, this.timeDelay);
    $(window).on('scroll click mousemove keydown touchstart touchmove', () => {
      this.setupVideoPlayers();
    });
  }

  delay(callback, ms = 2000) {
    const start = performance.now();

    const frame = (timestamp) => {
      const elapsed = timestamp - start;

      if (elapsed < ms) {
        requestAnimationFrame(frame);
      } else {
        callback();
      }
    };
    requestAnimationFrame(frame);
  }

  setupVideoPlayers() {
    if (this.videosSetup) {
      return;
    }

    $('.banner-video__iframe-container').each((_index, container) => {
      const videoUrl = $(container).data('videoUrl');
      const videoType = $(container).data('videoType');

      if (videoType === this.attributes.mediaLibrary) {
        // Create a video element for media library videos
        const video = $('<video>', {
          src: videoUrl,
          autoplay: '',
          loop: '',
          controls: false,
          class: 'video-player',
        });

        video.get(0).muted = true;
        video.get(0).setAttribute('playsinline', '');
        video.get(0).setAttribute('preload', 'auto');

        // Empty the container and append the video
        $(container).empty().append(video);

        // Make sure the video fills the container properly
        video.css({
          width: '100%',
          height: '100%',
          objectFit: 'cover',
        });

        // Start playing the video
        video[0].play().catch((error) => {
          console.log('Auto-play was prevented:', error);

          // Add a play button or other fallback if needed
        });
      } else {
        const iframe = $('<iframe>', {
          src: this.convertToEmbed(videoUrl),
          frameborder: '0',
          allow: 'autoplay; fullscreen; picture-in-picture',
          allowfullscreen: true,
          class: 'video-iframe',
          loading: 'lazy',
        });

        $(container).empty().append(iframe);

        // Force aspect ratio but ensure it covers the container
        this.adjustVideoSize(container);
        $(window).on('resize', () => this.adjustVideoSize(container));
      }
    });

    this.videosSetup = true;
  }

  /**
   * Adjusts the video iframe size to maintain aspect ratio while ensuring it covers the container
   * This function calculates the appropriate dimensions based on container and video ratios
   * If the container is wider than the video, it adjusts the height to maintain aspect ratio
   * If the container is taller than the video, it adjusts the width to maintain aspect ratio
   * In both cases, the video is centered within the container using CSS transform
   *
   * @param {HTMLElement} container - The DOM element containing the video iframe
   */
  adjustVideoSize(container) {
    const $container = $(container);
    const $iframe = $container.find('iframe');
    const containerWidth = $container.width();
    const containerHeight = $container.height();
    const containerRatio = containerWidth / containerHeight;
    const videoRatio = 16 / 9;

    if (containerRatio > videoRatio) {
      // Container is wider than video
      const newHeight = containerWidth / videoRatio;
      $iframe.css({
        width: containerWidth,
        height: newHeight,
        top: '50%',
        left: '50%',
        transform: `translate(-50%, -50%)`,
      });
    } else {
      // Container is taller than video
      const newWidth = containerHeight * videoRatio;
      $iframe.css({
        width: newWidth,
        height: containerHeight,
        top: '50%',
        left: '50%',
        transform: `translate(-50%, -50%)`,
      });
    }
  }

  convertToEmbed(url) {
    const urlYoutube = 'https://www.youtube.com/embed/'
    if (url.toLowerCase().indexOf('youtube.com') !== -1 && url.toLowerCase().indexOf('youtube.com/embed') === -1) {
      const tempV = url.split('?v=')[1]
      const v = tempV.split('&')[0]
      return `${urlYoutube + v}?autoplay=1&rel=0&showinfo=0&mute=1&controls=0&loop=1&playlist=${v}`
    }
    if (url.toLowerCase().indexOf('vimeo.com') !== -1 && url.toLowerCase().indexOf('player.vimeo.com/video') === -1) {
      const parts = url.split('/')
      const v2 = parts.pop()
      return `https://player.vimeo.com/video/${v2}?autoplay=1&muted=1&background=1&loop=1`
    }
    if (url.toLowerCase().indexOf('youtu.be') !== -1) {
      const parts2 = url.split('/')
      const v3 = parts2.pop()
      return `${urlYoutube + v3}?autoplay=1&rel=0&showinfo=0&mute=1&controls=0&loop=1&playlist=${v3}`
    }

    return url
  }
}

// Initialize the class
$(document).ready(() => {
  new BannerVideo();
});